const URLS = {
  CREATE_ACCOUNT_BUBBLE: '/auth/view/createaccount?fromReminder=true',
  SIGN_IN_BUBBLE: '/auth/view/signin?fromReminder=true'
};

export {
  URLS
};